// 潜客意向车型转成交到店统计
export default {
  field_from_api: {
    clue: {
      name: '线索',
      map: {
        count: {
          name: '合计',
          is_rate: false
        },
        rate: {
          name: '占比',
          is_rate: true
        }
      }
    },
    arrived: {
      name: '到店',
      map: {
        count: {
          name: '合计',
          is_rate: false
        },
        rate: {
          name: '到店率',
          is_rate: true
        }
      }
    },
    deal: {
      name: '成交',
      map: {
        count: {
          name: '合计',
          is_rate: false
        },
        rate: {
          name: '成交率',
          is_rate: true
        }
      }
    },
    clue_to_deal_rate: {
      name: '线索转化率',
      is_rate: true,
      map: {}
    }
  },
  getData (params) {
    this.$rest.dataAnalysis.getCarseriesAnalysis(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
